var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "1 1 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "transparent",
    d: "M5.94021 11.2863L6.2863 11.6471L5.94021 11.2863ZM6.9 7.875C6.9 9.071 6.40074 10.1518 5.59412 10.9254L6.2863 11.6471C7.28018 10.6939 7.9 9.35619 7.9 7.875L6.9 7.875ZM5.59412 4.82459C6.40074 5.59819 6.9 6.679 6.9 7.875L7.9 7.875C7.9 6.39381 7.28018 5.05607 6.2863 4.10287L5.59412 4.82459ZM6.2 3.625C8.57977 3.625 10.5 5.53271 10.5 7.875L11.5 7.875C11.5 4.97058 9.12216 2.625 6.2 2.625L6.2 3.625ZM10.5 7.875C10.5 10.2173 8.57977 12.125 6.2 12.125L6.2 13.125C9.12216 13.125 11.5 10.7794 11.5 7.875L10.5 7.875ZM6.2863 4.10287C6.16259 3.98422 6.11678 3.81172 6.13424 3.69592C6.14218 3.64326 6.15878 3.62818 6.15693 3.62996C6.14878 3.63779 6.15064 3.625 6.2 3.625L6.2 2.625C5.91614 2.625 5.6588 2.72189 5.46431 2.90866C5.27612 3.08937 5.17924 3.32248 5.14541 3.54684C5.07934 3.98508 5.23685 4.48195 5.59412 4.82459L6.2863 4.10287ZM5.59412 10.9254C5.23685 11.2681 5.07934 11.7649 5.14541 12.2032C5.17924 12.4275 5.27612 12.6606 5.46431 12.8413C5.6588 13.0281 5.91614 13.125 6.2 13.125L6.2 12.125C6.15065 12.125 6.14878 12.1122 6.15693 12.12C6.15878 12.1218 6.14218 12.1067 6.13424 12.0541C6.11678 11.9383 6.16259 11.7658 6.2863 11.6471L5.59412 10.9254Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.7769ff665c32e5be70a934178ce1e339.svg";
export { ForwardRef as ReactComponent };